export default __webpack_public_path__ + "static/media/logo.0f63a7c9.png";